import type { CastId } from "../../engine";
import { TEXTOS_UI } from "../ui/textos-ui";
import { TurnoDeDialogo } from "./TurnoDeDialogo";
import { ladoParaVozUnica } from "./lado-dialogo";

interface RespuestaDeMinijuegoProps {
  readonly speaker: CastId;
  readonly nombre: string;
  readonly texto: string;
  readonly contexto?: string;
  readonly alContinuar: () => void;
}

/** Presenta feedback hablado con la misma voz visual en todas las actividades. */
export function RespuestaDeMinijuego({
  speaker,
  nombre,
  texto,
  contexto,
  alContinuar,
}: RespuestaDeMinijuegoProps) {
  const lado = ladoParaVozUnica(speaker);
  return (
    <div className="minijuego__respuesta minijuego--respuesta">
      <div className="dialogo dialogo--visual dialogo--una-voz dialogo--compacto" data-lado={lado}>
        {contexto ? <p className="dialogo__contexto">{contexto}</p> : null}
        <div className="dialogo__turnos">
          <TurnoDeDialogo speaker={speaker} nombre={nombre} texto={texto} lado={lado} />
        </div>
        <div className="dialogo__controles">
          <button
            type="button"
            className="objetivo-tactil boton boton--primario dialogo__continuar"
            data-principal="true"
            onClick={alContinuar}
          >
            {TEXTOS_UI.dialogo.continuar}
          </button>
        </div>
      </div>
    </div>
  );
}
